import { WIX_STORES } from '@wix/app-definition-ids';
import { canAddProductToCart } from './utils/stores';
export const actions = {
    'tpa/addVariantToCart': async ({ wixSdk, currentItem }) => {
        const { window: windowApi, location: locationApi, site: siteApi } = wixSdk;
        const storesApi = await siteApi.getPublicAPI(WIX_STORES);
        const isMobile = windowApi.formFactor === 'Mobile';
        if (currentItem.managedVariant) {
            await storesApi.cart.addProducts([
                {
                    productId: currentItem.productId,
                    quantity: 1,
                    options: { choices: currentItem.choices },
                },
            ]);
            if (isMobile) {
                await storesApi.navigate.toCart();
            }
            else {
                storesApi.cart.showMinicart();
            }
        }
        else {
            if (isMobile) {
                const productPageUrl = await storesApi.product.getRelativeProductUrl({
                    id: currentItem.productId,
                });
                locationApi.to?.(productPageUrl);
            }
            else {
                await storesApi.product.openQuickView(currentItem.productId);
            }
        }
    },
    'tpa/addProductToCart': async ({ wixSdk, currentItem }) => {
        const { window: windowApi, location: locationApi, site: siteApi } = wixSdk;
        const storesApi = await siteApi.getPublicAPI(WIX_STORES);
        const isMobile = windowApi.formFactor === 'Mobile';
        if (canAddProductToCart(currentItem)) {
            await storesApi.cart.addProducts([
                { productId: currentItem._id, quantity: 1 },
            ]);
            if (isMobile) {
                await storesApi.navigate.toCart();
            }
            else {
                storesApi.cart.showMinicart();
            }
        }
        else {
            if (isMobile) {
                locationApi.to?.(currentItem.productPageUrl);
            }
            else {
                await storesApi.product.openQuickView(currentItem._id);
            }
        }
    },
    'tpa/quicklyViewProduct': async ({ wixSdk, currentItem }) => {
        const storesApi = await wixSdk.site.getPublicAPI(WIX_STORES);
        await storesApi.product.openQuickView(currentItem._id);
    },
    'tpa/purchasePricingPlan': async ({ wixSdk, currentItem }) => {
        await wixSdk['pricing-plans'].checkout.startOnlinePurchase(currentItem._id);
    },
    'tpa/pricingPlansNavigateToCheckout': async ({ wixSdk, currentItem, }) => {
        await wixSdk['pricing-plans'].customPurchaseFlow.navigateToCheckout({
            planId: currentItem._id,
        });
    },
};
//# sourceMappingURL=action-implementations.js.map